import {
  CommonActions,
  NavigationProp,
  RouteProp,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { useCallback } from "react";

import { HomeTabsNavigatorParamList } from "@/navigators/HomeTabsNavigator/types";

type EventsRouteParams = NonNullable<HomeTabsNavigatorParamList["Events"]>;

export const useClearQueryParam = () => {
  const navigation =
    useNavigation<NavigationProp<HomeTabsNavigatorParamList, "Events">>();
  const route = useRoute<RouteProp<HomeTabsNavigatorParamList, "Events">>();

  return useCallback(
    (paramName: keyof EventsRouteParams) => {
      navigation.dispatch({
        ...CommonActions.setParams({ [paramName]: undefined }),
        source: route.key,
      });
    },
    [navigation, route.key]
  );
};
